import React from 'react';
import { Subheader, PillContainer, Pill, Label } from './styles';

interface PillListProps {
  title: string;
  labels?: string[];
}

export default ({ title, labels = [] }: PillListProps) =>
  labels.length ? (
    <>
      <Subheader>{title}</Subheader>
      <PillContainer>
        {labels.map((label, i) =>
          label ? (
            <Pill key={`${label}-${i}`}>
              <Label>{label}</Label>
            </Pill>
          ) : null,
        )}
      </PillContainer>
    </>
  ) : null;
